import React from "react";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { useTranslation } from "react-i18next";
import IconSvg from "../../../../SharedComponents/IconSvg";
import PerfectScrollbar from "react-perfect-scrollbar";

const AssessmentVitrineCard = ({ assessment, onSelect, isPopular = false }) => {
  const { t } = useTranslation();

  const renderScopes = (scopes) => {
    if (!scopes || scopes.length === 0) return null;
    return (
      <ul className="text-12 mb-0 ps-3">
        {scopes.map((scope) => (
          <li key={scope.id} className="mb-1">
            {scope.name}
            {scope.subScopes && scope.subScopes.length > 0 && (
              <ul className="ps-3">
                {scope.subScopes.map((subScope) => (
                  <li key={subScope.id}>{subScope.name}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Card className="vitrine-card vitrine-card-assessment h-100 position-relative" onClick={() => onSelect(assessment)}>
      {/* Popular Badge */}
      {isPopular && (
        <div className="position-absolute top-0 end-0 m-3">
          <Badge bg="light" text="danger" className="d-flex align-items-center gap-1">
            <i className="bi bi-heart-fill"></i>
            <span>{t("popular")}</span>
          </Badge>
        </div>
      )}

      <Card.Body className="d-flex flex-column p-4">
        {/* Title */}
        <div className="mb-3">
          <h5 className="fw-bold mb-1">{assessment.name}</h5>
          <p className="text-muted small mb-0">{assessment.description}</p>
        </div>

        {/* Info Content - Expandable on hover */}
        <div className="vitrine-card-info flex-grow-1">
          <PerfectScrollbar options={{ suppressScrollX: true }}>
            {/* Inventories */}
            {assessment.inventories && assessment.inventories.length > 0 && (
              <div className="mb-3">
                <h6 className="text-primary fw-semibold mb-2 text-14">
                  {t("inventories") || "Envanterler"}
                </h6>
                {assessment.inventories.map((inventory) => (
                  <div key={inventory.id} className="mb-2">
                    <strong className="text-13">{inventory.name}</strong>
                    {renderScopes(inventory.scopes)}
                  </div>
                ))}
              </div>
            )}

            {/* Tests */}
            {assessment.tests && assessment.tests.length > 0 && (
              <div className="mb-3">
                <h6 className="text-success fw-semibold mb-2 text-14">{t("tests") || "Testler"}</h6>
                {assessment.tests.map((test) => (
                  <div key={test.id} className="mb-2">
                    <strong className="text-13">{test.name}</strong>
                    {renderScopes(test.scopes)}
                  </div>
                ))}
              </div>
            )}

            {/* Surveys */}
            {assessment.surveys && assessment.surveys.length > 0 && (
              <div className="mb-3">
                <h6 className="text-warning fw-semibold mb-2 text-14">{t("surveys") || "Anketler"}</h6>
                {assessment.surveys.map((survey) => (
                  <div key={survey.id} className="mb-2">
                    <strong className="text-13">{survey.name}</strong>
                    {renderScopes(survey.scopes)}
                  </div>
                ))}
              </div>
            )}
          </PerfectScrollbar>
        </div>

        {/* Footer with Details Button */}
        <div className="mt-auto pt-3 border-top">
          <button className="btn btn-outline-dark w-100 rounded-pill">{t("details")}</button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AssessmentVitrineCard;
